module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@2x-936c3b587eb02918312d14ee31116507.png";